module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ssTabList"
  }, [(_vm.opMsg) ? _c('div', {
    staticClass: "rejects"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("原因：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v(_vm._s(_vm.opMsg))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("中华XXXXXXX杂志（电子版）")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("打印")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.tabDat), function(term, inx) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(term.updatedAt, 'time')))]), _vm._v(" "), _c('td', [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(term)
        }
      }
    }, [_vm._v("查看")])], 1), _vm._v(" "), (inx == 0) ? _c('td', {
      attrs: {
        "rowspan": "3"
      }
    }, [(term.code == '401') ? _c('a', {
      attrs: {
        "href": _vm.printUrl
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.print(term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : (term.code == '404') ? _c('a', {
      attrs: {
        "href": _vm.printUrl1
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.print(term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : _vm._e()]) : (inx == 3) ? _c('td', [(term.code == '401') ? _c('a', {
      attrs: {
        "href": _vm.printUrl
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.print(term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : (term.code == '404') ? _c('a', {
      attrs: {
        "href": _vm.printUrl1
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.print(term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : _vm._e()]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("状态：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v("退回")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("连续型电子出版物出版情况登记表")]), _vm._v(" "), _c('td', [_vm._v("查阅时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4821c62c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/pressComps/CommonsSive.vue
// module id = 1730
// module chunks = 1